import axios from 'axios';
import router from './router/index.js';
import { settings } from './setting.js';
import notification from 'ant-design-vue/es/notification'

let isHttps = document.location.protocol === 'https:';
let evnSet = settings();

const service = axios.create({
  timeout: 60000 //请求超时时间
});
// 添加request拦截器
service.interceptors.request.use(config => {
  const token = localStorage.getItem('LOGIN_ACCESS_TOKEN')
  if (token) {
    config.headers['WeAppAuthorization'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  config.headers['Content-Type'] = 'application/json;charset=UTF-8'
  return config;
}, err => {
  Promise.reject(err);
});

// 添加response拦截器
service.interceptors.response.use(response => {
  const message = response.data && response.data.message ? response.data.message : ''
  if(message.indexOf('请登陆后') > -1){
    notification.error({
      message: '错误',
      description: '登陆超时，请重新登陆'
    })
    localStorage.setItem('LOGIN_ACCESS_TOKEN', '')
    router.push({path: '/login'})
  }else {
    return response.data;
  }
}, err => {
  const message = err.response.data && err.response.data.message ? err.response.data.message : ''
  if(message.indexOf('请登陆后') > -1){
    notification.error({
      message: '错误',
      description: '登陆超时，请重新登陆'
    })
    localStorage.setItem('LOGIN_ACCESS_TOKEN', '')
    router.push({path: '/login'})
  }else if (err.response && err.response.status === 404) {
    router.push('@/pages/exception/404.vue');
  } else if (err.response && err.response.status === 500) {
    router.push('@/pages/exception/500.vue');
  }
   return Promise.reject(err.response);
});

export function post(url, method, data = []) {
  const token = localStorage.getItem('LOGIN_ACCESS_TOKEN')
  let param = {
    method: method,
    rpc: 'rabbitmq',
    params: data,
    id: 1
  };
  let sendObject = {
    url: isHttps ? `${evnSet.endpoints}` + url : `${evnSet.endpoint}` + url,
    method: 'post',
    data: param
  };
  sendObject.data = JSON.stringify(param);
  return service(sendObject);
}

export {
  service as axios
}



// WEBPACK FOOTER //
// ./src/axios.js